import React from 'react'

export default function Label(props) {
    return (
        <label
            htmlFor={props.title}
            className="flexed-section-v1"
        >
            {props.children}
        </label>
    );
}
